import { pinwallApiUrl, pinwallApiKey } from '../../config'
import store from '../../store'
var md5 = require('md5');

// getters
const getters = {
  pinwalls: state => state.pinwalls,
  selectedPinwall: state => state.pinwall,
  pinwallAssets: state => state.pinwallAssets
}

const actions = {
  loadPinwalls(context) {
    return new Promise((resolve, reject) => {
      const client = store.state.user.tenantName === 'swisstxt' ? '' : store.state.user.tenantName;
      const url = `${pinwallApiUrl}/api/get?client=${client}&hash="${new Date().getTime()}`
      fetch(url, {
        method: "get",
        headers: {
          "Authorization": md5(pinwallApiKey)
      }
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadPinwalls', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  loadPinwallAssets(context, data) {
    return new Promise((resolve, reject) => {
      const url = `${pinwallApiUrl}/api/get?id=${data.id}&password=${data.password}&visit=false&fbUserId=&gUserId=&hash=${new Date().getTime()}`
      fetch(url, {
        method: "get",
        headers: {
          "Authorization": md5(pinwallApiKey + data.id + data.password)
      }
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadPinwallAssets', data)
        resolve()
      }).catch(e => {
        data.password = null;
        data.visible = false;
        context.commit('setPinwall', data)
        console.error(e)
        reject()
      });
    })
  },
  setPinwall(context, pinwall) {
    context.commit('setPinwall', pinwall)
  }
}

const mutations = {
  setPinwall(state, pinwall) {
    if (pinwall.visible) {
      state.pinwalls.map(pinwall => {
        pinwall.visible = false
      })
    }
    pinwall.visible = !pinwall.visible
    Object.assign(state.pinwall, pinwall)
    state.pinwallAssets = []
  },
  loadPinwalls(state, items) {
    items.map(item => {
      item.visible = false
      item.password = ""
      item.image = item.image ? item.image.replace('http:', '').replace(':8090', '') : ''
      const pinwall = state.pinwalls.find((element) => {
        return element.id === item.id
      })
      if (pinwall) {
        item.password = pinwall.password
      }
    })
    state.pinwalls = items
  },
  loadPinwallAssets(state, data) {
    if (data && data.messages) {
      state.pinwallAssets = []
      data.messages.forEach(msg => {
        if (msg.image) {
          msg.image = msg.image.startsWith('//') ? `https:${msg.image}` : msg.image.replace('http:', 'https:')
          state.pinwallAssets.push({
            msgId: msg.id,
            type: 'image',
            url: msg.image.replace(':8090', ''),
            name: /[^/]*$/.exec(msg.image)[0].replace(`_${data.id}`, '')
          })
        }
        if (msg.video && !msg.video.includes('youtube') && !msg.video.includes('kaltura') && !msg.video.includes('cling')) {
          msg.video = msg.video.startsWith('//') ? `https:${msg.video}` : msg.video.replace('http:', 'https:')
          state.pinwallAssets.push({
            msgId: msg.id,
            type: 'video',
            url: msg.video.replace(':8090', ''),
            name: /[^/]*$/.exec(msg.video)[0].replace(`_${data.id}`, '')
          })
        }
        if (msg.audio) {
          msg.audio = msg.audio.startsWith('//') ? `https:${msg.audio}` : msg.audio.replace('http:', 'https:')
          state.pinwallAssets.push({
            msgId: msg.id,
            type: 'audio',
            url: msg.audio.replace(':8090', ''),
            name: /[^/]*$/.exec(msg.audio)[0].replace(`_${data.id}`, '')
          })
        }
        if (msg.file) {
          msg.file = msg.file.startsWith('//') ? `https:${msg.file}` : msg.file.replace('http:', 'https:')
          state.pinwallAssets.push({
            msgId: msg.id,
            type: /[^.]*$/.exec(msg.file)[0],
            url: msg.file.replace(':8090', ''),
            name: /[^/]*$/.exec(msg.file)[0].replace(`_${data.id}`, '')
          })
        }
      });
      state.pinwalls.map(pinwall => {
        if (pinwall.id === data.id) {
          pinwall.password = data.password;
        }
      })
    } else {
      state.pinwallAssets = []
    }
  }
}
export default {
  state: initializeState(),
  mutations,
  actions,
  getters
}

function initializeState() {
  return {
    pinwalls: [],
    pinwall: {
      visible: false
    },
    pinwallAssets: []
  }
}
